/**
 * @generated SignedSource<<3e9cdf7dbfc2cedb3ef627667298f75f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OnboardingLookingForScreenQuery$variables = Record<PropertyKey, never>;
export type OnboardingLookingForScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OnboardingLookingForView_query">;
};
export type OnboardingLookingForScreenQuery = {
  response: OnboardingLookingForScreenQuery$data;
  variables: OnboardingLookingForScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingLookingForScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OnboardingLookingForView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OnboardingLookingForScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": [
              "SEQUENCE_ASC"
            ]
          }
        ],
        "concreteType": "RelationshipTypeConnection",
        "kind": "LinkedField",
        "name": "relationshipTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RelationshipType",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rowId",
                "storageKey": null
              },
              (v0/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "relationshipTypes(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": [
                  "RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC"
                ]
              }
            ],
            "concreteType": "UserRelationshipTypeConnection",
            "kind": "LinkedField",
            "name": "userRelationshipTypes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserRelationshipType",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relationshipTypeId",
                    "storageKey": null
                  },
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "userRelationshipTypes(orderBy:[\"RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC\"])"
          },
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "65d86464bbefff90d6a0842e731cc8b5",
    "id": null,
    "metadata": {},
    "name": "OnboardingLookingForScreenQuery",
    "operationKind": "query",
    "text": "query OnboardingLookingForScreenQuery {\n  ...OnboardingLookingForView_query\n}\n\nfragment OnboardingLookingForView_query on Query {\n  relationshipTypes(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n  ...useUserRelationshipTypes_query\n}\n\nfragment useUserRelationshipTypes_query on Query {\n  currentUser {\n    userRelationshipTypes(orderBy: [RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC]) {\n      nodes {\n        relationshipTypeId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0be3ecae39d3ee947876458f6380fb19";

export default node;
